/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      // Sainté (okt 2026): skifter kunden land, følger sproget med - Danmark
      // på dansk, alle andre lande på engelsk. Sættes før den forsinkede
      // submit (200 ms), så formularen sender begge dele i ét hop.
      const country = this.form.querySelector('select[name="country_code"]');
      if (country) {
        country.addEventListener('change', () => {
          const lang = country.value === 'DK' ? 'da' : 'en';
          const sel = this.form.querySelector('select[name="locale_code"]');
          if (sel) {
            if (Array.prototype.some.call(sel.options, (o) => o.value === lang)) sel.value = lang;
          } else {
            let hidden = this.form.querySelector('input[name="locale_code"]');
            if (!hidden) {
              hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'locale_code';
              this.form.appendChild(hidden);
            }
            hidden.value = lang;
          }
        });
      }
      this.inputs.forEach(item => item.addEventListener('change', this.debouncedOnSubmit.bind(this)));
    }
    onSubmitHandler(event) {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}